import gql from 'graphql-tag'

export const LINKS_EXTERNOS = gql`
  query LinksExternosQuery($id: ID!) {
    linksExternosByProduto(id: $id) {
      id
      label
      uri
      uriHomolog
    }
  }
`
